// Import Swiper and modules
import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

import './style.scss';

window.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll('[data-swiper-slider]')
		.forEach(function (swiper) {
			// Options
			const attr = JSON.parse(swiper.dataset.swiperSlider);

			const autoplay = attr.autoplay ? true : false;
			const autoplayDelay = attr.autoplayDelay
				? parseInt(attr.autoplayDelay)
				: 3000;
			const freeMode = attr.freeMode === 'true' ? true : false;
			const effect = attr.effect ? attr.effect : 'slide';
			const loop = attr.loop ? true : false;
			const speed = attr.speed ? parseInt(attr.speed) : 400;
			const slidesPerView = attr.slidesPerView
				? parseFloat(attr.slidesPerView)
				: 1;
			const spaceBetween = attr.spaceBetween
				? parseInt(attr.spaceBetween)
				: 0;
			const navigation = attr.navigation ? true : false;
			const pagination = attr.pagination ? true : false;
			const paginationType = attr.paginationType
				? attr.paginationType
				: 'fraction';
			swiper = new Swiper(swiper, {
				modules: [Navigation, Pagination, EffectFade],
				slideClass: 'swiper-slide',
				// Default parameters
				slidesPerView: 1,
				spaceBetween,
				// Responsive breakpoints
				breakpoints: {
					// when window width is >= 640px
					640: {
						slidesPerView: 2,
						spaceBetween,
					},
					// when window width is >= 820px
					820: {
						slidesPerView,
						spaceBetween,
					},
				},
				speed,
				autoplay: autoplay
					? {
							delay: autoplayDelay,
					  }
					: false,
				loop,
				freeMode,
				effect,
				fadeEffect:
					effect === 'fade'
						? {
								crossFade: true,
						  }
						: false,
				navigation: navigation
					? {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
					  }
					: false,
				pagination: pagination
					? {
							el: '.swiper-pagination',
							type: paginationType,
					  }
					: false,
			});
		});
});
